import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { CreateSaveCustomerContact, getCustomerContact } from '../../../../actions/customers'
import { loginAs } from '../../../../actions/auth'

// import styles
import './view.scss'

// Components
import Phone from '../../../../shared/components/Phone'
import HelpText from '../../../../shared/components/HelpText'

import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Switch from '../../../../shared/elements/switch'
import Text from '../../../../shared/elements/text'
import Button from '../../../../shared/elements/button'
import Grid from '../../../../shared/elements/grid'
import Check from '../../../../shared/elements/check'

// Utils
import { hasSubscriptionPermission, isTopOfStackChain, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { translation, enumtranslate } from '../../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'edit',
      contact: {
        UserId: 0,
        CustomerId: 0,
        UserName: '',
        Email: '',
        EmailIsValid: false,
        Phone: '',
        PhoneCode: this.props.phonecode,
        PhoneIsValid: false,
        Active: true,
        NotificationSettings: []
      }
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.saveAddContact = this.saveAddContact.bind(this)
    this.loginAs = this.loginAs.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getCustomerContact(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.UserId !== nextProps.item.UserId) {
      this.getCustomerContact(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      contact: {
        ...this.state.contact,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (this.state.contact.UserId !== undefined) {
      this.setState({ type: 'edit' }, () => {
        this.saveAddContact()
      })
    }
  }

  loginAs (id) {
    this.props.loginAs(id).then((res) => {
      this.props.router.push('/')
    }, (err) => {
      if (err.response.data.DictionaryKey !== undefined) {
        window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
      }
      console.log('Nooooo, could not login', err.response.data)
    })
  }

  getCustomerContact (props) {
    if (typeof props.item.UserId !== 'undefined') {
      props.getCustomerContact(props.item.UserId).then((res) => {
        let contact = res.data
        if (contact.NotificationSettings.length === 0) {
          contact.NotificationSettings = this.getNotificationSettings()
        }
        this.setState({
          type: 'edit',
          contact: contact
        })
      }, () => {
        this.props.onError()
      })
    } else {
      this.resetCreate()
    }
  }

  getNotificationSettings () {
    let NotificationSettings = [...this.state.contact.NotificationSettings]
    NotificationSettings.map((val, key) => {
      NotificationSettings[key] = {
        NotificationEvent: val.NotificationEvent,
        Sms: false,
        Email: false,
        Push: false
      }
    })
    return NotificationSettings
  }

  resetCreate () {
    this.setState({
      type: 'create',
      contact: {
        UserId: 0,
        CustomerId: this.props.customerID,
        Phone: '',
        PhoneCode: this.props.phonecode,
        PhoneIsValid: false,
        Active: true,
        NotificationSettings: this.getNotificationSettings(),
        UserName: '',
        Email: '',
        EmailIsValid: false
      }
    })
  }

  onInputChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (name === 'PhoneNumber') {
      name = 'Phone'
      this.setState({
        contact: {
          ...this.state.contact,
          [name]: value
        }
      })
    } else {
      this.setState({
        contact: {
          ...this.state.contact,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      })
    }
  }

  renderContact () {
    let { contact } = this.state
    let disableInputs = false
    // Check if LoginAs is allowed
    // let isLoginAsAllowed = !contact.HidePassword // && this.props.auth.departmentType !== 1// !this.props.hidePassword // (contact.UserId > 0) && hasAccess([3, 5, 7], this.props.auth.user.UserType) && !this.props.hidePassword
    // Allow LoginAs if the first logged in user is chain
    let isLoginAsAllowed = true // GDPR - TO BE CHANGED
    if (isTopOfStackChain(this.props.auth.inactiveUsers)) {
      isLoginAsAllowed = true
    }
    isLoginAsAllowed = contact.AllowLoginAs

    if (contact.IsPartnerUser) {
      disableInputs = true
    }

    // let a = 1
    // Return
    return (
      <Panel title={translation('346')}>
        <Text name='Name' value={contact.Name || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={disableInputs} labelText={translation('30')} />
        <Text name='UserName' value={contact.UserName || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={disableInputs} labelText={translation('1')} />

        {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && (
          <Text name='Email' value={contact.Email || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={disableInputs} labelText={translation('1052')} />
        )}

        {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && (
          <LabelWrapper labelText={translation('345')}>
            <Phone
              onChange={this.onInputChange}
              onBlur={this.onBlur}
              code={contact.PhoneCode}
              number={contact.Phone}
              disabled={disableInputs} />
          </LabelWrapper>
        )}

        {!contact.IsPartnerUser && (
          <Switch name='Active' onChange={this.onChange} checked={contact.Active} labelText={translation('295')} />
        )}

        {(isLoginAsAllowed && this.state.type !== 'create') && (
          <Button style='link' onClick={this.loginAs.bind(this, contact.UserId)} labelText={translation('57')} />
        )}
      </Panel>
    )
  }

  renderNotifications () {
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return null
    let { contact } = this.state
    let disableCheckboxEmail = false
    let disableCheckboxSMS = false
    if (contact.NotificationSettings.length === 0) return null

    const renderNotification = (val, key) => {
      if (!this.props.isOwnedByShop && (val.NotificationEvent === 1 || val.NotificationEvent === 2)) return null
      let name = 'notification_' + val.NotificationEvent + '_'
      let keyName = enumtranslate('NotificationEventType', val.NotificationEvent)
      let helpText = ''
      switch (val.NotificationEvent) {
        case 1:
          helpText = '2169'
          break
        case 2:
          helpText = '2170'
          break
        case 3:
          helpText = '2171'
          break
        case 4:
          helpText = '2198'
          break
        case 5:
          helpText = '2172'
          break
        case 6:
          helpText = '2173'
          break
        case 7:
          helpText = '1969'
          break
        case 8:
          helpText = '1970'
          break
        case 9:
          helpText = '1971'
          break
        case 10:
          helpText = '1972'
          break
        case 11:
          helpText = '1973'
          break
        case 12:
          helpText = '2197'
          break
        case 13:
          helpText = '2174'
          break
        case 14:
          helpText = '13709'
          break
        case 18:
          helpText = '15150'
      }
      // On change
      const onChange = (e) => {
        let NotificationSettings = [...this.state.contact.NotificationSettings]
        if (e.target.name === 'sms') {
          NotificationSettings[key].Sms = e.target.checked
        } else if (e.target.name === 'email') {
          NotificationSettings[key].Email = e.target.checked
        }
        this.setState({
          contact: {
            ...this.state.contact,
            NotificationSettings: NotificationSettings
          }
        })
        this.onBlur()
      }

      if (!contact.EmailIsValid || contact.IsPartnerUser) {
        disableCheckboxEmail = true
      }

      if (!contact.PhoneIsValid || contact.IsPartnerUser) {
        disableCheckboxSMS = true
      }

      // Return
      return (
        <Grid spacing={1} cols={[3]} align='center' key={key}>
          <span>{translation(keyName)} <HelpText text={translation(helpText)} /></span>
          <Check simple id={name + 'email'} name='email' value='1' checked={val.Email} onChange={onChange} disabled={disableCheckboxEmail} />
          <Check simple id={name + 'sms'} name='sms' value='1' checked={val.Sms} onChange={onChange} disabled={disableCheckboxSMS} />
        </Grid>
      )
    }
    // Return
    return (
      <Panel title={translation('13461')} helpText={translation('14739')}>
        <Grid cols={[3]} align='center' spacing={1}>
          <span />
          <span>{translation('1052')}</span>
          <span>{translation('15')}</span>
        </Grid>
        {contact.NotificationSettings.map(renderNotification)}
      </Panel>
    )
  }

  saveAddContact () {
    this.props.CreateSaveCustomerContact(this.state.contact).then((res) => {
      this.props.onSave(res.data, this.state.type)
      this.setState({
        contact: res.data
      })
    }, (err) => {
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        if (this.state.contact.Email !== '' && this.state.contact.UserName !== '') {
          let errors = err.response.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        }
      } else {
        const errorMessage = (error) => {
          let messageText = ''
          if (error < 5) {
            messageText += translation('16340')
          }
          if (messageText !== '') messageText += ' '
          switch (error) {
            case 1:
              messageText += translation('16329')
              break
            case 2:
              messageText += translation('16336')
              break
            case 3:
              messageText += translation('16335')
              break
            case 4:
              messageText += translation('16338')
              break
            case 5:
              messageText += translation('16337')
              break
            default:
              break
          }
          messageText += '<br>'
          return messageText
        }
        let errors = err.response.data
        if (Array.isArray(errors)) {
          let message = errors.map(error => errorMessage(error))
          window.toastr.error(message, translation('216'))
        } else {
          window.toastr.error(translation('13463'), translation('216'))
        }
      }
    })
  }

  render () {
    return (
      <div>
        <Col>
          {this.renderContact()}
        </Col>
        {hasSubscriptionPermission(this.props.auth, 20) && this.props.auth.departmentType !== 1 && (
          <Col>{this.renderNotifications()}</Col>
        )}
      </div>
    )
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode
  }
}

export default connect(mapStateToProps, {
  CreateSaveCustomerContact,
  getCustomerContact,
  loginAs
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Customers/Contacts/View/index.js